<div class="matrix-fab-wrapper" [style.left.px]="fabX" (pointerdown)="startDrag($event)">
  <button
    nz-button
    nzType="default"
    nzShape="circle"
    nzSize="large"
    type="button"
    class="matrix-fab"
    [title]="open() ? 'Close Ask Matrix' : 'Open Ask Matrix'"
    [attr.aria-label]="open() ? 'Close Ask Matrix' : 'Open Ask Matrix'"
    (click)="onFabClick($event)"
  >
    @if (!open()) {
      <img src="/images/favicon.png" alt="Ask Matrix" class="matrix-logo" />
    }

    @if (open()) {
      <span nz-icon nzType="close" nzTheme="outline" class="matrix-close-icon"></span>
    }
  </button>
</div>
@if (open()) {
  <div class="chat-panel" [class.chat-panel-left]="isFabLeft" [class.chat-panel-right]="!isFabLeft">
    <div class="chat-header">
      <div class="title">Ask Matrix</div>
      <button nz-button nzType="text" (click)="close()">
        <span nz-icon nzType="close"></span>
      </button>
    </div>
    <div class="chat-body" #scrollContainer (scroll)="onChatScroll()">
      @for (msg of messages(); track msg) {
        <div
          class="message"
          [class.user]="msg.role === 'user'"
          [class.assistant]="msg.role === 'assistant'"
        >
          @if (msg.role === 'assistant') {
            <div (click)="onEntityClick($event)" class="message-content">
              <markdown [data]="msg.content"></markdown>
              <!-- {{ msg.content }} -->
            </div>
          }
          @if (msg.role === 'user') {
            <div class="message-content">
              {{ msg.content }}
            </div>
          }
        </div>
      }
      @if (loading()) {
        <div nz-flex [nzJustify]="'center'" [nzAlign]="'center'">
          <app-loader></app-loader>
        </div>
      }
      @if (showScrollButton) {
        <button
          type="button"
          class="scroll-bottom-btn"
          aria-label="Scroll to latest message"
          title="Scroll to latest message"
          (click)="scrollToBottom($event)"
        >
          <nz-icon nzType="arrow-down" nzTheme="outline"></nz-icon>
        </button>
      }
    </div>
    <div class="chat-footer">
      <input
        class="custom-input w-100 d-block"
        nz-input
        placeholder="Ask anything..."
        [(ngModel)]="input"
        (keydown.enter)="send()"
      />
      <button
        nzType="primary"
        class="btn-primary"
        style="min-width: 70px"
        (click)="send()"
        [disabled]="loading()"
      >
        <nz-icon class="me-1" nzType="arrow-up" nzTheme="outline" />
        Send
      </button>
    </div>
  </div>
}
